import { Link } from '@mui/material'

export default function SupportButton({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <Link
      href='mailto:support@webwisdom.ai?subject=Dashboard Support Request'
      underline='none'
      fontSize={12}
      color='text.secondary'
      aria-label='Contact Support'
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {children}
    </Link>
  )
}
